import {Program} from '../../beam/index';

import copyVS from '../shaders/copy-vs.glsl';
import copyFS from '../shaders/copy-fs.glsl';

export default class CopyRenderPass {

    constructor(renderer) {
        this.renderer = renderer
        this.material = new Program(this.renderer.gl,{
            vertexShader:   copyVS,
            fragmentShader: copyFS,
            depthTest:      false,
            blend:          true,
			blendSrcRGB:    this.renderer.gl.ONE,
			blendDstRGB:    this.renderer.gl.ONE,
			blendSrcAlpha:  this.renderer.gl.ONE,
            blendDstAlpha:  this.renderer.gl.ONE,
        });
    }

    render(bufferScene, bufferPlane, bufferCamera, input, output) {
        bufferPlane.material = this.material
        this.material.setUniform('tInput', input);
        this.renderer.render(bufferScene, bufferCamera, output);
    }

}